import { render, staticRenderFns } from "./election.vue?vue&type=template&id=a114cbd2&scoped=true&"
import script from "./election.vue?vue&type=script&lang=js&"
export * from "./election.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a114cbd2",
  null
  
)

export default component.exports